import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { SignalBinding } from "signals";
import { slotModel } from "slotworks/model/slot-model";
import { ButtonControl } from "./button-control";

export class AutoStartControl extends ButtonControl {

    protected modelSignalBinding: SignalBinding;

    constructor(protected button: FlexiButton) {
        super(button);
        this.setEnabled(false);
        this.modelSignalBinding = slotModel.onUpdate.add(() => this.setEnabled(true));
        this.checkEnabled();
    }

    public setEnabled(enabled?: boolean) {
        super.setEnabled(enabled && this.checkEnabled());
    }

    public destroy() {
        this.modelSignalBinding.detach();

        super.destroy();
    }

    protected checkEnabled(): boolean {
        const autoplay = slotModel.read().autoplay;
        return autoplay.autoplays.currentValue > 0 && autoplay.lossLimit.currentValue > 0;
    }

    protected onClick(): void {
        Services.autoplay.start();
        stateMachine.skip();
    }
}
